import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'app-popup-reload-page',
  templateUrl: './popup-reload-page.component.html'
})
export class PopupReloadPageComponent {

  constructor(
    public dialogRef: MatDialogRef<PopupReloadPageComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {
    dialogRef.disableClose = false;
  }

  onNoClick() {
    this.dialogRef.close();
  }

  reloadPage() {
    this.dialogRef.close(true);
  }

}
